import { flow, types, applySnapshot } from 'mobx-state-tree';

import api from '../utils/api';
import NextPreviewStore from './NextPreviewStore';
import responseIs404 from '../utils/responseIs404';

const Entity = types.optional(types.map(types.frozen), {
  content: [],
  nextPreview: NextPreviewStore,
});

export const PostStore = types
  .model('Post', {
    entity: Entity,
    notFound: types.optional(types.boolean, false),
  })
  .actions(self => ({
    load: flow(function* load(id) {
      self.notFound = false;
      const response = yield api.newsPost(id);
      if (responseIs404(response)) {
        self.notFound = true;
        return;
      }
      applySnapshot(self.entity, yield response.json());
    }),
  }));

export default PostStore;



// WEBPACK FOOTER //
// ./src/stores/PostStore.js